import React from 'react';

import { SVGComponentProps } from './svg.types';

const AlignLeftSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.04175 12.3957C2.04175 12.6373 1.84587 12.8332 1.60425 12.8332C1.36263 12.8332 1.16675 12.6373 1.16675 12.3957V1.604C1.16675 1.36238 1.36263 1.1665 1.60425 1.1665C1.84587 1.1665 2.04175 1.36238 2.04175 1.604V12.3957ZM12.8334 5.0165C12.8334 5.50655 12.8334 5.75157 12.738 5.93875C12.6542 6.10337 12.5203 6.23725 12.3557 6.32113C12.1685 6.4165 11.9235 6.4165 11.4334 6.4165H5.19175C4.7017 6.4165 4.45668 6.4165 4.2695 6.32113C4.10486 6.23725 3.97101 6.10337 3.88712 5.93875C3.79175 5.75157 3.79175 5.50655 3.79175 5.0165V4.89984C3.79175 4.40979 3.79175 4.16477 3.88712 3.97759C3.97101 3.81295 4.10486 3.6791 4.2695 3.59521C4.45668 3.49984 4.7017 3.49984 5.19175 3.49984H11.4334C11.9235 3.49984 12.1685 3.49984 12.3557 3.59521C12.5203 3.6791 12.6542 3.81295 12.738 3.97759C12.8334 4.16477 12.8334 4.40979 12.8334 4.89984V5.0165ZM8.65471 10.6054C8.75008 10.4182 8.75008 10.1732 8.75008 9.68317V9.5665C8.75008 9.07645 8.75008 8.83145 8.65471 8.64425C8.57082 8.47964 8.43695 8.34576 8.27233 8.26188C8.08514 8.1665 7.84014 8.1665 7.35008 8.1665H5.19175C4.7017 8.1665 4.45668 8.1665 4.2695 8.26188C4.10486 8.34576 3.97101 8.47964 3.88712 8.64425C3.79175 8.83145 3.79175 9.07645 3.79175 9.5665V9.68317C3.79175 10.1732 3.79175 10.4182 3.88712 10.6054C3.97101 10.77 4.10486 10.9039 4.2695 10.9878C4.45668 11.0832 4.7017 11.0832 5.19175 11.0832H7.35008C7.84014 11.0832 8.08514 11.0832 8.27233 10.9878C8.43695 10.9039 8.57082 10.77 8.65471 10.6054Z"
        fill="white"
      />
    </svg>
  );
};

export default AlignLeftSVG;
